import { render } from "./DataGeneratorModal.vue?vue&type=template&id=f81e2eec&scoped=true"
import script from "./DataGeneratorModal.vue?vue&type=script&lang=js"
export * from "./DataGeneratorModal.vue?vue&type=script&lang=js"

import "./DataGeneratorModal.vue?vue&type=style&index=0&id=f81e2eec&lang=scss"
import "./DataGeneratorModal.vue?vue&type=style&index=1&id=f81e2eec&lang=scss&scoped=true"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81e2eec"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
